import {GlobalStyles} from './global/styles';
import { Home } from './pages/Home';

function App() {
  return (
    <>
      <GlobalStyles />
      <Home />
    </>
  );
}

export default App;
